t = require('app/scripts/views/internal/teacup-with-helpers')('calendar_day_list_header')

module.exports = ->
  t.span '.calendar-list-header', { name: t.mustacheVar('listID') }, ->
    t.icon 'list'
    t.text ' '
    t.text t.mustacheVar('listName')
